import { route } from '../../constants.ts';
import { createAction } from '@reduxjs/toolkit';
import type { UnderlayViewType } from '@repperjs/shared/src/@types/UnderlayViewType';
import { SnapshotFavoriteFilterType } from '@repperjs/shared/src/@types/SnapshotFavoriteFilterType';
import type { ViewMode } from '@repperjs/shared/src/@types/ViewMode';

export const CHANGE_DROPZONE_SOURCE_ABORTED = `${route}/CHANGE_DROPZONE_SOURCE_ABORTED`;
export const CHANGE_VECTOR_RENDER_TYPE = `${route}/CHANGE_VECTOR_RENDER_TYPE`;

export const changeDropzoneSource = createAction<{ source: any }>(`${route}/CHANGE_DROPZONE_SOURCE`);

export const changeViewMode = createAction<{ viewMode: ViewMode }>(`${route}/CHANGE_VIEW_MODE`);

export const changeUnderlayViewId = createAction<{ id: string }>(`${route}/CHANGE_UNDERLAY_VIEW_ID`);

export const changeUnderlayIsOpen = createAction<{ isOpen: boolean }>(`${route}/CHANGE_UNDERLAY_IS_OPEN`);

export const openUnderlay = createAction<{ viewId: UnderlayViewType; immediate: boolean }>(`${route}/OPEN_UNDERLAY`);

export const changeSnapshotViewType = createAction<{ viewType: string }>(`${route}/CHANGE_SNAPSHOT_VIEW_TYPE`);

export const changeSnapshotsFavoriteFilter = createAction<{ favoriteFilter: SnapshotFavoriteFilterType }>(
    `${route}/CHANGE_SNAPSHOT_FAVORITE_FILTER`,
);

export const enableTouchUI = createAction(`${route}/ENABLE_TOUCH_UI`);

export const changeOnlineStatus = createAction<{ online: boolean }>(`${route}/CHANGE_ONLINE_STATUS`);

export const changeInteracting = createAction<{ interacting: boolean }>(`${route}/CHANGE_INTERACTING`);

export const changeLoadProjectSort = createAction<{ sortOption: string }>(`${route}/CHANGE_LOAD_PROJECT_SORT`);

export const changeProjectsSearchQuery = createAction<{ searchQuery: string }>(`${route}/CHANGE_PROJECTS_SEARCH_QUERY`);

export const changeShowInterface = createAction<{ show: boolean; immersive?: boolean }>(
    `${route}/CHANGE_SHOW_INTERFACE`,
);

export const changeShowShaderInfo = createAction<{ show: boolean }>(`${route}/CHANGE_SHOW_SHADER_INFO`);

export const changeWindowSize = createAction<{
    width: number;
    height: number;
}>(`${route}/CHANGE_WINDOW_SIZE`);

export const changeEditorViewport = createAction<{
    x: number;
    y: number;
    width: number;
    height: number;
}>(`${route}/CHANGE_EDITOR_VIEWPORT`);

export const handleError = createAction<{
    error: any;
    errorInfo: any;
    name: string;
    source: string;
    fatal: boolean;
    group: string;
}>(`${route}/HANDLE_ERROR`);

export const resetError = createAction(`${route}/RESET_ERROR`);

export const changeVectorRenderType = createAction<{ vectorRenderType: string }>(`${route}/CHANGE_VECTOR_RENDER_TYPE`);

export const changeViewOption = createAction<{
    id: string;
    value: any;
    group: string;
    groupId: string;
    transient?: boolean;
}>(`${route}/CHANGE_VIEW_OPTION`);

export const updateInteraction = createAction<{ trigger: string }>(`${route}/UPDATE_INTERACTION`);

export const updateImageCameraEnabled = createAction<{ enabled: boolean }>(`${route}/UPDATE_IMAGE_CAMERA_ENABLED`);
